import React from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {Button, Container, I18NText, Icon, Text, useIcons,} from '@yosmanyga/rich-ui';
import {PlayInputNotePromptController} from '../../controller';

const PlayInputNotePrompt = observer(() => {
    const playInputNotePromptController = useService(
        PlayInputNotePromptController,
        []
    );

    const icons = useIcons();

    if (!playInputNotePromptController.note) {
        return null;
    }

    return <Container
        flow="column"
        align={{
            cross: 'center',
        }}
    >
        <Container
            flow="row"
            align={{
                cross: 'center',
            }}
        >
            <I18NText>Save note?</I18NText>
            <Button
                onClick={() => {
                    playInputNotePromptController.cancel();
                }}
                margin={{
                    left: 1,
                }}
            >
                <Icon component={icons.actions.cancel}/>
            </Button>
            <Button
                progress={playInputNotePromptController.executing}
                onClick={async () => {
                    await playInputNotePromptController.execute();
                }}
                margin={{
                    left: 1,
                }}
            >
                <Icon component={icons.actions.ok}/>
            </Button>
        </Container>
        <Text>{playInputNotePromptController.note}</Text>
    </Container>
});

export {PlayInputNotePrompt};
